import React from "react";
import { getBundledLanguageFiles, LanguageFile } from "./Languages";

export const LanguageContext = React.createContext<LanguageFile>(getBundledLanguageFiles().de_AT);

export function provideLanguageContext(reactElement: React.ReactNode, language: LanguageFile): React.FunctionComponentElement<React.ProviderProps<LanguageFile>> {
  return React.createElement(LanguageContext.Provider, { key: "languageContext", value: language }, [reactElement]);
}